var _desc, _defs, _rect, _rect2, _rect3, _path, _rect4, _rect5, _path2, _path3, _path4, _path5, _g, _rect6, _rect7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _rect8, _rect9, _ellipse, _polygon, _polygon2, _polygon3, _ellipse2, _path6, _polyline, _rect10, _polygon4, _polygon5, _path7, _polygon6, _polygon7, _ellipse3, _path8, _rect11, _path9, _rect12, _path10, _ellipse4, _polygon8, _polygon9, _rect13, _rect14, _rect15, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _rect16, _rect17, _ellipse5, _polygon10, _polygon11, _polygon12, _ellipse6, _path11, _polyline2, _rect18, _polygon13, _polygon14, _path12, _polygon15, _polygon16, _ellipse7, _path13, _rect19, _path14, _rect20, _path15, _ellipse8, _polygon17, _polygon18, _rect21, _polygon19, _path16, _polygon20, _path17, _polygon21, _polygon22, _path18, _polygon23, _path19, _polygon24, _polygon25, _path20, _polygon26, _path21, _polygon27, _path22, _path23, _g2, _polyline3, _path24, _path25, _path26, _path27, _path28, _g3, _g4, _g5, _g6, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _path29, _rect22, _path30, _rect23, _path31;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1656px",
    height: "1328px",
    viewBox: "0 0 1656 1328",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-signup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9617108%",
    y1: "0.884735202%",
    x2: "50.9392122%",
    y2: "126.82866%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4%",
    y1: "49.9941294%",
    x2: "100%",
    y2: "49.9941294%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9617108%",
    y1: "0.884735202%",
    x2: "50.9377106%",
    y2: "126.82866%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9629446%",
    y1: "0.876249039%",
    x2: "50.9393543%",
    y2: "126.825519%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9610918%",
    y1: "0.876249039%",
    x2: "50.9375015%",
    y2: "126.825519%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "illustration-signup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SIGN-UP-01"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0.85,
    y: 0.45,
    width: 1655.19,
    height: 1327.55
  })), /*#__PURE__*/React.createElement("g", {
    id: "TABLE",
    transform: "translate(187.000000, 652.000000)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#752A31",
    fillRule: "nonzero",
    x: 25.35,
    y: 43.56,
    width: 913.46,
    height: 488.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#752A31",
    fillRule: "nonzero",
    x: 0.13,
    y: 0.19,
    width: 963.44,
    height: 47.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.13,545.47 L963.58,545.47 C963.58,527.084441 948.675559,512.18 930.29,512.18 L33.42,512.18 C15.0344407,512.18 0.13,527.084441 0.13,545.47 Z",
    id: "Path",
    fill: "#752A31"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#471117",
    fillRule: "nonzero",
    x: 25.35,
    y: 46.27,
    width: 913.46,
    height: 16.84
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#9A4E57",
    fillRule: "nonzero",
    x: 25.35,
    y: 131.05,
    width: 913.01,
    height: 313.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.9,444.51 L455.67,444.51 L455.67,131.05 L459.9,131.05 L459.9,444.51 Z M508,131.05 L503.77,131.05 L503.77,444.51 L508,444.51 L508,131.05 Z M363.59,131.05 L359.35,131.05 L359.35,444.51 L363.59,444.51 L363.59,131.05 Z M652.42,131.05 L648.18,131.05 L648.18,444.51 L652.42,444.51 L652.42,131.05 Z M556.14,131.05 L551.9,131.05 L551.9,444.51 L556.14,444.51 L556.14,131.05 Z M604.28,131.05 L600.04,131.05 L600.04,444.51 L604.28,444.51 L604.28,131.05 Z M411.72,131.05 L407.49,131.05 L407.49,444.51 L411.72,444.51 L411.72,131.05 Z M70.55,444.51 L74.79,444.51 L74.79,131.05 L70.55,131.05 L70.55,444.51 Z M122.93,131.05 L118.69,131.05 L118.69,444.51 L122.93,444.51 L122.93,131.05 Z M171.07,131.05 L166.83,131.05 L166.83,444.51 L171.07,444.51 L171.07,131.05 Z M315.49,131.05 L311.25,131.05 L311.25,444.51 L315.49,444.51 L315.49,131.05 Z M219.21,131.05 L215,131.05 L215,444.51 L219.24,444.51 L219.21,131.05 Z M267.35,131.05 L263.11,131.05 L263.11,444.51 L267.35,444.51 L267.35,131.05 Z M845.02,131.05 L840.78,131.05 L840.78,444.51 L845,444.51 L845.02,131.05 Z M700.6,131.05 L696.36,131.05 L696.36,444.51 L700.6,444.51 L700.6,131.05 Z M748.74,131.05 L744.5,131.05 L744.5,444.51 L748.74,444.51 L748.74,131.05 Z M796.88,131.05 L792.64,131.05 L792.64,444.51 L796.88,444.51 L796.88,131.05 Z M893.16,131.05 L888.92,131.05 L888.92,444.51 L893.16,444.51 L893.16,131.05 Z",
    id: "Shape",
    fill: "#752A31",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(72.000000, 129.000000)",
    fill: "#471117",
    fillRule: "nonzero"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.51,67.74 L180.46,49.84 L198.39,49.84 C204.76,37.69 207.79,25.69 206.86,13.84 C206.482236,10.4153918 203.799715,7.69975409 200.38,7.28 C136.450647,-2.39502146 71.429353,-2.39502146 7.5,7.28 C4.12514208,7.71128478 1.46650446,10.3658132 1.03,13.74 C-0.24,26.15 2.94,38.25 9.62,49.82 L27.31,49.82 L29.26,67.72 L34.26,67.72 L12.64,416.45 L21.12,416.45 L55.12,67.72 L103,67.72 L115.12,316.41 L31.26,316.41 L28.93,336.53 L116.07,336.53 L119.96,416.45 L128.44,416.45 L127.38,336.53 L175.6,336.53 L183.39,416.45 L191.86,416.45 L170.24,67.74 L178.51,67.74 Z M173.64,316.43 L127.11,316.43 L123.8,67.74 L149.41,67.74 L173.64,316.43 Z",
    id: "Shape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M466.71,67.74 L468.66,49.84 L486.59,49.84 C492.96,37.69 495.98,25.69 495.05,13.84 C494.679281,10.4120404 491.993153,7.69275072 488.57,7.28 C424.640647,-2.39502146 359.619353,-2.39502146 295.69,7.28 C292.317398,7.71215467 289.662155,10.3673978 289.23,13.74 C287.95,26.15 291.13,38.25 297.81,49.82 L315.51,49.82 L317.51,67.72 L322.51,67.72 L300.89,416.45 L309.36,416.45 L343.36,67.72 L391.21,67.72 L403.32,316.41 L319.46,316.41 L317.13,336.53 L404.26,336.53 L408.16,416.45 L416.63,416.45 L415.57,336.53 L463.8,336.53 L471.58,416.45 L480.06,416.45 L458.44,67.74 L466.71,67.74 Z M461.84,316.43 L415.3,316.43 L412,67.74 L437.61,67.74 L461.84,316.43 Z",
    id: "Shape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M756.81,67.74 L758.81,49.84 L776.74,49.84 C783.12,37.69 786.14,25.69 785.21,13.84 C784.832236,10.4153918 782.149715,7.69975409 778.73,7.28 C714.800647,-2.39502146 649.779353,-2.39502146 585.85,7.28 C582.475142,7.71128478 579.816504,10.3658132 579.38,13.74 C578.11,26.15 581.29,38.25 587.97,49.82 L605.66,49.82 L607.61,67.72 L612.61,67.72 L591,416.47 L599.48,416.47 L633.48,67.74 L681.32,67.74 L693.44,316.43 L609.57,316.43 L607.24,336.55 L694.37,336.55 L698.26,416.47 L706.74,416.47 L705.68,336.55 L753.9,336.55 L761.69,416.47 L770.16,416.47 L748.54,67.74 L756.81,67.74 Z M751.94,316.43 L705.41,316.43 L702.11,67.74 L727.71,67.74 L751.94,316.43 Z",
    id: "Shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANT",
    transform: "translate(1155.000000, 810.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.52,12.67 C85.46,-20.99 60.88,21.76 64.31,64.67 C67.56,105.36 102.64,244.96 96.13,303.67 L109.56,303.67 C142.41,228.38 160.83,55.75 118.52,12.67 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.63,303.68 C136.63,184.98 96.12,20.91 95.98,20.35 C95.7314719,19.3337961 94.7062039,18.7114719 93.69,18.96 C92.6737961,19.2085281 92.0514719,20.2337961 92.3,21.25 C92.43,21.81 132.96,186.07 100.74,303.68 L104.63,303.68 Z",
    id: "Path",
    fill: "#752A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,86.83 C2.17,68.38 -6.62,108.64 7,141.95 C18.25,169.56 68,251.22 86.77,303.68 L104.47,303.68 C105.91,231.18 78.09,108.62 37,86.83 Z",
    id: "Path",
    fill: "#FCD828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.94,303.68 C86.42,205.62 21.21,99.03 20.94,98.68 C20.6470422,98.1959051 20.1180765,97.9048741 19.5523592,97.9161978 C18.9866418,97.928197 18.4701187,98.2407793 18.1973592,98.7365356 C17.9245996,99.2322919 17.9370422,99.8359051 18.23,100.32 C18.46,100.71 83.23,206.61 94.76,303.71 L97.94,303.68 Z",
    id: "Path",
    fill: "#752A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,133.37 C217.94,118.63 223.29,156.77 208.3,186.85 C198.15,207.21 161.58,259.34 136.95,303.68 L108.85,303.68 C118.46,236.6 149.29,148.62 184.19,133.37 Z",
    id: "Path",
    fill: "#FEF4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.88,303.68 C142.88,222.41 198.05,145.82 198.27,145.51 C198.747726,144.844497 199.674497,144.692274 200.34,145.17 C201.005503,145.647726 201.157726,146.574497 200.68,147.24 C200.46,147.54 145.85,223.34 121.94,303.68 L118.88,303.68 Z",
    id: "Path",
    fill: "#752A31"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#752A31",
    fillRule: "nonzero",
    x: 52.86,
    y: 298.91,
    width: 109.66,
    height: 35.17,
    rx: 5.38
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#752A31",
    points: "75.21 318.77 140.18 318.77 157.15 334.09 143.29 387.47 107.69 387.47 72.1 387.47 58.24 334.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#471117",
    points: "157.15 334.09 154.3 345.06 61.09 345.06 58.24 334.09"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MENU",
    transform: "translate(271.000000, 116.000000)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#122737",
    fillRule: "nonzero",
    transform: "translate(254.470000, 143.640000) rotate(90.000000) translate(-254.470000, -143.640000) ",
    x: 111.16,
    y: -110.59,
    width: 286.62,
    height: 508.46
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 8.23,
    y: 8.32,
    width: 492.49,
    height: 270.65
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 48.37,
    x2: 213.74,
    y2: 48.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 73.51,
    x2: 233.16,
    y2: 73.51,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 83.9,
    x2: 233.16,
    y2: 83.9,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 94.3,
    x2: 233.16,
    y2: 94.3,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 105.54,
    x2: 233.16,
    y2: 105.54,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 175.45,
    x2: 213.74,
    y2: 175.45,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 200.58,
    x2: 233.16,
    y2: 200.58,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 210.98,
    x2: 233.16,
    y2: 210.98,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 221.37,
    x2: 233.16,
    y2: 221.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 136.99,
    y1: 232.62,
    x2: 233.16,
    y2: 232.62,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 48.37,
    x2: 432.41,
    y2: 48.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 73.51,
    x2: 451.83,
    y2: 73.51,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 83.9,
    x2: 451.83,
    y2: 83.9,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 94.3,
    x2: 451.83,
    y2: 94.3,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 105.54,
    x2: 451.83,
    y2: 105.54,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 175.45,
    x2: 432.41,
    y2: 175.45,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 200.58,
    x2: 451.83,
    y2: 200.58,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 210.98,
    x2: 451.83,
    y2: 210.98,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 221.37,
    x2: 451.83,
    y2: 221.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 355.66,
    y1: 232.62,
    x2: 451.83,
    y2: 232.62,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 8.23,
    y: 8.32,
    width: 492.49,
    height: 32.58
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 8.23,
    y: 234.43,
    width: 492.49,
    height: 44.54
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 76.14,
    cy: 113.63,
    rx: 22.18,
    ry: 1.96
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "79.06 33.55 69.39 33.38 63.56 33.29 64.66 52.01 70.46 52.23 78.97 52.54 101.32 53.38 102.27 33.95"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    fillRule: "nonzero",
    points: "78.97 52.54 70.46 52.23 64.66 52.01 68.27 113.63 73.96 113.63 78.65 113.63 98.35 113.63 101.32 53.38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    fillRule: "nonzero",
    points: "98.85 53.28 96.13 112.14 69.39 112.14 69.39 110.01 91.24 108.06 91.55 53.01"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "69.39 33.38 70.46 52.23 73.96 113.63 78.65 113.63 78.97 52.54 79.06 33.55"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 291.63,
    cy: 114.78,
    rx: 19.11,
    ry: 2.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.11,32.41 L290.17,47.41 C290.168442,50.600312 289.330595,53.7344803 287.74,56.5 L282.67,65.31 C282.324478,65.9196116 282.145161,66.6092945 282.149905,67.31 L282.149905,113.8 C282.147333,114.117337 282.27153,114.422593 282.494988,114.647929 C282.718446,114.873265 283.022652,115 283.34,115 L309.54,115 C309.85826,115 310.163484,114.873572 310.388528,114.648528 C310.613572,114.423484 310.740002,114.11826 310.740002,113.8 L310.740002,67.5 C310.740675,66.7760804 310.539847,66.0662598 310.16,65.45 L305.07,56.39 C303.53,53.66 303.14,51.31 302.72,47.45 L300.96,32.45 L291.11,32.41 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "310.74 74.8 293.09 74.8 293.09 105.81 310.74 105.81"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    fillRule: "nonzero",
    x: 289.47,
    y: 28.33,
    width: 13.12,
    height: 4.17,
    rx: 0.93
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE1E2D",
    fillRule: "nonzero",
    points: "300.96 32.41 291.11 32.41 291 34.17 301.17 34.17"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "298.38 47.53 290.21 47.53 290.73 38.35 298.38 38.35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.74,76.12 C309.236465,76.3326958 307.718146,76.4229924 306.2,76.39 C303.31,76.47 299.2,76.53 294.29,76.57 L294.75,76.12 C294.75,80.34 294.75,85.12 294.81,90.26 C294.87,95.4 294.81,100.18 294.75,104.39 L294.29,103.94 C299.2,103.94 303.29,104.05 306.2,104.13 C307.717806,104.097699 309.235805,104.184632 310.74,104.39 C309.237115,104.609105 307.718261,104.699434 306.2,104.66 C303.31,104.74 299.2,104.81 294.29,104.85 L293.84,104.85 L293.84,104.39 C293.84,100.18 293.84,95.39 293.78,90.26 C293.72,85.13 293.78,80.34 293.84,76.12 L293.84,75.66 L294.29,75.66 C299.2,75.66 303.29,75.76 306.2,75.84 C307.718417,75.8103191 309.236738,75.90396 310.74,76.12 L310.74,76.12 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291,68.62 C291.13,65.92 295.85,57.97 296.36,54.62 C296.68,52.43 296.45,40.51 296.25,32.43 L293.84,32.43 C293.84,38.08 293.84,45.43 293.78,49.36 C293.59,56.24 287.5,61.5 286.15,66.08 C284.97,70.08 284.3,106.08 284.15,115.02 L291,115.02 C291,106.12 290.88,71 291,68.62 Z",
    id: "Path",
    fill: "#EDF5F6",
    fillRule: "nonzero",
    opacity: 0.33,
    style: {
      mixBlendMode: "screen"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    points: "453.34 8.34 373.77 87.91 182.72 278.97 246.36 278.97 373.77 151.55 500.71 24.61 500.71 8.32"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.35,
    points: "373.77 8.32 261.18 8.32 8.23 261.22 8.23 278.97 141.52 278.97 373.77 46.72 412.17 8.32"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 79.55,
    cy: 251.94,
    rx: 25.58,
    ry: 2.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.26,162.51 L109,162.51 L109,208.45 C109,216.767408 102.257408,223.51 93.94,223.51 L74.34,223.51 C66.0225917,223.51 59.28,216.767408 59.28,208.45 L59.28,162.51 L59.26,162.51 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 80.27,
    y: 220.82,
    width: 7.69,
    height: 29.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.13,252 L63.13,252 C63.1355139,249.595945 65.0859383,247.65 67.49,247.65 L100.81,247.65 C103.212439,247.65 105.16,249.597561 105.16,252 L105.13,252 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 63.87,
    y: 181.99,
    width: 40.5,
    height: 11.02
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.87,189.17 L63.87,203 C63.8810192,211.771236 70.9887637,218.878981 79.76,218.89 L88.47,218.89 C97.2451413,218.884491 104.358971,211.775136 104.37,203 L104.37,189.17 L63.87,189.17 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.9,162.51 C64.06,174.27 64.82,213.31 68.36,222.62 C69.927017,223.207127 71.5866027,223.508562 73.26,223.51 L77.41,223.51 C76.21,217.34 70.13,185.13 69.77,162.51 L63.9,162.51 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 288.91,
    cy: 256.13,
    rx: 19.75,
    ry: 1.96
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "300.76 253.17 292.21 253.17 279.06 166.36 313.92 166.36"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8963D",
    fillRule: "nonzero",
    points: "294.48 250.54 285.24 189.6 307.74 189.6 298.5 250.54"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 282.35,
    y: 251.53,
    width: 26.31,
    height: 4.6
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "298.5 251.53 286.03 166.36 285.75 166.36 293.83 251.53"
  }), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#122737",
    fillRule: "nonzero",
    transform: "translate(804.910000, 143.650000) rotate(90.000000) translate(-804.910000, -143.650000) ",
    x: 661.6,
    y: -110.58,
    width: 286.62,
    height: 508.46
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 558.68,
    y: 8.32,
    width: 492.49,
    height: 270.65
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 48.37,
    x2: 764.19,
    y2: 48.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 73.51,
    x2: 783.61,
    y2: 73.51,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 83.9,
    x2: 783.61,
    y2: 83.9,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 94.3,
    x2: 783.61,
    y2: 94.3,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 105.54,
    x2: 783.61,
    y2: 105.54,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 175.45,
    x2: 764.19,
    y2: 175.45,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 200.58,
    x2: 783.61,
    y2: 200.58,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 210.98,
    x2: 783.61,
    y2: 210.98,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 221.37,
    x2: 783.61,
    y2: 221.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 687.44,
    y1: 232.62,
    x2: 783.61,
    y2: 232.62,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 48.37,
    x2: 982.86,
    y2: 48.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 73.51,
    x2: 1002.28,
    y2: 73.51,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 83.9,
    x2: 1002.28,
    y2: 83.9,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 94.3,
    x2: 1002.28,
    y2: 94.3,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 105.54,
    x2: 1002.28,
    y2: 105.54,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 175.45,
    x2: 982.86,
    y2: 175.45,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 200.58,
    x2: 1002.28,
    y2: 200.58,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 210.98,
    x2: 1002.28,
    y2: 210.98,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 221.37,
    x2: 1002.28,
    y2: 221.37,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 906.11,
    y1: 232.62,
    x2: 1002.28,
    y2: 232.62,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 558.68,
    y: 8.32,
    width: 492.49,
    height: 32.58
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 558.68,
    y: 234.43,
    width: 492.49,
    height: 44.54
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 626.59,
    cy: 113.63,
    rx: 22.18,
    ry: 1.96
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "629.51 33.55 619.84 33.38 614.01 33.29 615.11 52.01 620.91 52.23 629.42 52.54 651.77 53.38 652.72 33.95"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    fillRule: "nonzero",
    points: "629.42 52.54 620.91 52.23 615.11 52.01 618.72 113.63 624.41 113.63 629.1 113.63 648.8 113.63 651.77 53.38"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    fillRule: "nonzero",
    points: "649.29 53.28 646.58 112.14 619.84 112.14 619.84 110.01 641.69 108.06 642 53.01"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "619.84 33.38 620.91 52.23 624.41 113.63 629.1 113.63 629.42 52.54 629.51 33.55"
  }), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 842.08,
    cy: 114.78,
    rx: 19.11,
    ry: 2.06
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M841.56,32.41 L840.62,47.41 C840.618442,50.600312 839.780595,53.7344803 838.19,56.5 L833.12,65.31 C832.774478,65.9196116 832.595161,66.6092945 832.599905,67.31 L832.599905,113.8 C832.597333,114.117337 832.72153,114.422593 832.944988,114.647929 C833.168446,114.873265 833.472652,115 833.79,115 L860,115 C860.662742,115 861.200002,114.462742 861.200002,113.8 L861.200002,67.5 C861.200675,66.7760804 860.999847,66.0662598 860.62,65.45 L855.52,56.39 C853.99,53.66 853.6,51.31 853.18,47.45 L851.42,32.45 L841.56,32.41 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "861.19 74.8 843.54 74.8 843.54 105.81 861.19 105.81"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    fillRule: "nonzero",
    x: 839.92,
    y: 28.33,
    width: 13.12,
    height: 4.17,
    rx: 0.93
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE1E2D",
    fillRule: "nonzero",
    points: "851.41 32.41 841.56 32.41 841.45 34.17 851.62 34.17"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "848.83 47.53 840.65 47.53 841.18 38.35 848.83 38.35"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M861.19,76.12 C859.683134,76.3329296 858.161473,76.4232259 856.64,76.39 C853.76,76.47 849.64,76.53 844.74,76.57 L845.2,76.12 C845.2,80.34 845.2,85.12 845.2,90.26 C845.2,95.4 845.2,100.18 845.2,104.39 L844.74,103.94 C849.65,103.94 853.74,104.05 856.65,104.13 C858.167806,104.097699 859.685805,104.184632 861.19,104.39 C859.687115,104.609105 858.168261,104.699434 856.65,104.66 C853.76,104.74 849.65,104.81 844.74,104.85 L844.29,104.85 L844.29,104.39 C844.29,100.18 844.29,95.39 844.23,90.26 C844.17,85.13 844.23,80.34 844.29,76.12 L844.29,75.66 L844.74,75.66 C849.65,75.66 853.74,75.76 856.64,75.84 C858.161744,75.8100855 859.683406,75.9037263 861.19,76.12 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M841.45,68.62 C841.58,65.92 846.3,57.97 846.81,54.62 C847.13,52.43 846.9,40.51 846.7,32.43 L844.29,32.43 C844.29,38.08 844.29,45.43 844.23,49.36 C844.04,56.24 837.94,61.5 836.6,66.08 C835.42,70.08 834.75,106.08 834.6,115.02 L841.43,115.02 C841.42,106.12 841.33,71 841.45,68.62 Z",
    id: "Path",
    fill: "#EDF5F6",
    fillRule: "nonzero",
    opacity: 0.33,
    style: {
      mixBlendMode: "screen"
    }
  }), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    points: "1003.79 8.34 924.22 87.91 733.17 278.97 796.81 278.97 924.22 151.55 1051.16 24.61 1051.16 8.32"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.35,
    points: "924.22 8.32 811.63 8.32 558.68 261.22 558.68 278.97 691.97 278.97 924.22 46.72 962.62 8.32"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 630,
    cy: 251.94,
    rx: 25.58,
    ry: 2.15
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M609.71,162.51 L659.43,162.51 L659.43,208.45 C659.43,216.767408 652.687408,223.51 644.37,223.51 L624.77,223.51 C616.452592,223.51 609.71,216.767408 609.71,208.45 L609.71,162.51 L609.71,162.51 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 630.72,
    y: 220.82,
    width: 7.69,
    height: 29.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M655.58,252 L613.58,252 C613.585514,249.595945 615.535938,247.65 617.94,247.65 L651.26,247.65 C653.662439,247.65 655.61,249.597561 655.61,252 L655.58,252 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 614.32,
    y: 181.99,
    width: 40.5,
    height: 11.02
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M614.32,189.17 L614.32,203 C614.331019,211.771236 621.438764,218.878981 630.21,218.89 L638.92,218.89 C647.693519,218.884484 654.804484,211.773519 654.81,203 L654.81,189.17 L614.32,189.17 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M614.35,162.51 C614.5,174.27 615.27,213.31 618.81,222.62 C620.377017,223.207127 622.036603,223.508562 623.71,223.51 L627.86,223.51 C626.66,217.34 620.58,185.13 620.22,162.51 L614.35,162.51 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    }
  }), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 839.36,
    cy: 256.13,
    rx: 19.75,
    ry: 1.96
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "851.21 253.17 842.66 253.17 829.51 166.36 864.37 166.36"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8963D",
    fillRule: "nonzero",
    points: "844.93 250.54 835.69 189.6 858.19 189.6 848.95 250.54"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 832.8,
    y: 251.53,
    width: 26.31,
    height: 4.6
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "848.95 251.53 836.48 166.36 836.2 166.36 844.28 251.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CHAIRS",
    transform: "translate(277.000000, 781.000000)",
    fillRule: "nonzero"
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "31.26 316.43 181.96 316.43 184.45 336.55 28.93 336.55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.39,49.84 L9.62,49.84 C2.94,38.27 -0.24,26.17 1.03,13.76 C1.46650446,10.3858132 4.12514208,7.73128478 7.5,7.3 C71.429353,-2.37502146 136.450647,-2.37502146 200.38,7.3 C203.799715,7.71975409 206.482236,10.4353918 206.86,13.86 C207.79,25.69 204.76,37.69 198.39,49.84 Z",
    id: "Path",
    fill: "#F26341"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "178.51 67.74 29.26 67.74 27.31 49.84 180.46 49.84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.12,67.74 L19.32,435.22 L11.51,435.22 L34.29,67.74 L55.12,67.74 Z M102.97,67.74 L120.88,435.22 L128.69,435.22 L123.8,67.74 L102.97,67.74 Z",
    id: "Shape",
    fill: "#27384A"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "149.41 67.74 185.21 435.22 193.03 435.22 170.24 67.74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.52,13.81 C7.11,22.81 8.67,32.86 12.63,43.54 L65.63,43.54 L85.76,12.32 C121.76,11.83 159.76,12.41 199.36,13.81 C190.23,3.41 31.57,0 9.52,13.81 Z",
    id: "Path",
    fill: "#EDE0A0",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AB1E36",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    points: "192.62 18.15 188.31 43.54 141.57 43.54 137.26 16.85"
  }), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "319.46 316.43 470.16 316.43 472.65 336.55 317.13 336.55"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M486.59,49.84 L297.81,49.84 C291.13,38.27 287.95,26.17 289.23,13.76 C289.662155,10.3873978 292.317398,7.73215467 295.69,7.3 C359.619353,-2.37502146 424.640647,-2.37502146 488.57,7.3 C491.993153,7.71275072 494.679281,10.4320404 495.05,13.86 C496,25.69 493,37.69 486.59,49.84 Z",
    id: "Path",
    fill: "#F26341"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "466.71 67.74 317.46 67.74 315.51 49.84 468.66 49.84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M343.32,67.74 L307.52,435.22 L299.7,435.22 L322.49,67.74 L343.32,67.74 Z M391.17,67.74 L409.07,435.22 L416.88,435.22 L412,67.74 L391.17,67.74 Z",
    id: "Shape",
    fill: "#27384A"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "437.61 67.74 473.41 435.22 481.22 435.22 458.44 67.74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,13.81 C295.3,22.81 296.86,32.86 300.83,43.54 L353.83,43.54 L373.97,12.32 C409.97,11.83 447.97,12.41 487.57,13.81 C478.42,3.41 319.76,0 297.71,13.81 Z",
    id: "Path",
    fill: "#EDE0A0",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AB1E36",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    points: "480.82 18.15 476.51 43.54 429.77 43.54 425.46 16.85"
  }), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "609.57 316.43 760.26 316.43 762.76 336.55 607.24 336.55"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M776.69,49.84 L587.92,49.84 C581.24,38.27 578.06,26.17 579.33,13.76 C579.766504,10.3858132 582.425142,7.73128478 585.8,7.3 C649.729353,-2.37502146 714.750647,-2.37502146 778.68,7.3 C782.099715,7.71975409 784.782236,10.4353918 785.16,13.86 C786.09,25.69 783.06,37.69 776.69,49.84 Z",
    id: "Path",
    fill: "#F26341"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "756.82 67.74 607.56 67.74 605.62 49.84 758.76 49.84"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M633.43,67.74 L597.62,435.22 L589.81,435.22 L612.59,67.74 L633.43,67.74 Z M681.27,67.74 L699.18,435.22 L707,435.22 L702.12,67.74 L681.27,67.74 Z",
    id: "Shape",
    fill: "#27384A"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "727.71 67.74 763.51 435.22 771.33 435.22 748.54 67.74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M587.82,13.81 C585.41,22.81 586.97,32.86 590.93,43.54 L643.93,43.54 L664,12.32 C700,11.83 738,12.41 777.61,13.81 C768.53,3.41 609.87,0 587.82,13.81 Z",
    id: "Path",
    fill: "#EDE0A0",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AB1E36",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    points: "770.92 18.15 766.61 43.54 719.88 43.54 715.56 16.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MAN",
    transform: "translate(586.000000, 313.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.31,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(137.818460, 934.771397) rotate(-21.110000) translate(-137.818460, -934.771397) ",
    cx: 137.81846,
    cy: 934.771397,
    rx: 39.9,
    ry: 13.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.43,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(89.000000, 339.000000)",
    fill: "#000000"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.71,554.34 L53.71,558.49 L56.71,554.34 Z",
    id: "Path"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M254,0.19 L96.21,0.19 L93.59,32.87 L96.84,33.08 L93.37,51.44 C92.97,51.33 92.73,51.28 92.7,51.35 C92.67,51.42 92.9,51.56 93.3,51.79 L0.3,544.57 L14.44,544.57 C14.3,544.86 14.16,545.17 14.01,545.47 L65.21,545.47 C65.21,545.18 65.21,544.88 65.21,544.57 L73.61,544.57 L160.37,111.11 L147.56,541.28 L157.62,541.07 L157.36,545.47 L224.09,545.47 C223.22,545.12 222.22,544.82 221.36,544.57 C220.732785,544.469708 220.104437,544.742903 219.75,545.27 L215.98,543.27 C216.33,542.49 216.56,541.96 216.56,541.96 C216.94,541.12 215.82,540.42 214.4,539.87 L224.7,539.65 L246.27,60.28 L247,43 L256.81,43.65 C257,38.61 255.76,21.52 254,0.19 Z M209.89,540.08 L209.69,539.97 L209.99,539.97 L209.89,540.08 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MAN-2"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SHOES",
    transform: "translate(98.000000, 871.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.83,14.16 L214.83,0 L166.7,0 L163.94,46.93 L233.53,47.45 L241,28 C228.52,21.4 214.83,14.16 214.83,14.16 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15,38.43 C260.42,38.16 251.15,33.28 241.02,27.98 L233.53,47.45 L261.64,47.66 C261.93,43.64 262.09,38.78 261.15,38.43 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15,53 C261.15,53 261.43,50.55 261.64,47.67 L163.94,46.94 L163.66,51.58 L261.15,53 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,23.26 C234.18,23.26 231.18,30.26 230.34,30.34 C229.5,30.42 224.4,29.73 224.74,27.98 C225.08,26.23 227.29,19.7 229.45,20.33 C231.61,20.96 234.77,21.93 234.18,23.26 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,17.73 C224.65,17.73 221.65,24.73 220.81,24.81 C219.97,24.89 214.88,24.2 215.21,22.45 C215.54,20.7 217.76,14.17 219.93,14.8 C222.1,15.43 225.25,16.4 224.65,17.73 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,79.82 C32.54,78.47 72.18,27.12 73,23.72 C73.2727584,21.9603956 73.3898784,20.1801726 73.35,18.4 C65.35,29.47 32.99,73.84 30.35,75.4 C16.96,83.32 5.62,77.98 0.51,74.56 C0.549416755,75.7943699 0.700026226,77.0226738 0.96,78.23 C0.96,78.23 13.39,90.34 32,79.82 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,4.31 L28.23,8.31 C28.23,8.31 15.4,34.91 7.34,52.79 C16.16,50.96 30.06,50.58 41.56,61.46 C52.48,47.03 68.1,25.58 73.35,18.35 C73.4,12.49 73,4.31 73,4.31 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33,52.84 C3.88,60.48 1.33,66.53 0.99,68.22 C0.595718853,70.2987539 0.444703005,72.4163317 0.54,74.53 C5.65,77.95 16.99,83.29 30.38,75.37 C31.28,74.84 35.75,69.16 41.55,61.51 C30.05,50.63 16.15,51 7.33,52.84 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.64,20.55 C34.75,21.05 48.79,24.55 47.71,27.16 C46.63,29.77 40.01,29.08 38.92,28.78 C37.83,28.48 28.92,25.91 28.29,24.97 C27.66,24.03 28.12,20.41 29.64,20.55 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.66,29.3 C30.77,29.79 44.81,33.3 43.73,35.91 C42.65,38.52 36.04,37.83 34.95,37.52 C33.86,37.21 24.95,34.66 24.31,33.72 C23.67,32.78 24.14,29.15 25.66,29.3 Z",
    id: "Path",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PANTS",
    transform: "translate(106.000000, 372.000000)"
  }, _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#2B2D6E",
    points: "247.91 0.6 224.79 514.42 147.65 516.05 160.46 85.87 73.69 519.33 0.35 519.33 98.3 0.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M173.31,7.11 C173.021566,8.13327943 172.857055,9.18749278 172.82,10.25 C172.61,12.25 172.35,15.25 172.05,18.85 C171.47,26.12 170.76,36.16 170.05,47.26 C169.73,52.79 169.43,58.06 169.14,62.91 C168.85,67.76 168.87,72.08 167.66,75.41 C166.806794,78.0767477 164.934069,80.2981381 162.45,81.59 C161.48113,81.9758436 160.476141,82.2639405 159.45,82.45 C159.45,82.45 159.73,82.56 160.28,82.58 C161.090959,82.5771036 161.894418,82.4245481 162.65,82.13 C165.450011,80.9455419 167.626021,78.6425983 168.65,75.78 C170.08,72.23 170.16,67.78 170.52,62.99 C170.88,58.2 171.19,52.88 171.52,47.35 C172.21,36.25 172.74,26.2 173.06,18.92 C173.22,15.27 173.32,12.33 173.36,10.29 C173.468594,9.2317285 173.451811,8.16433431 173.31,7.11 L173.31,7.11 Z",
    id: "Path",
    fill: "#0F1235"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M165.39,13.93 C165.27,14.13 166.04,14.63 166.11,15.85 C166.162905,16.4945097 165.945573,17.1320166 165.51,17.61 C164.942353,18.0775041 164.163936,18.1957844 163.483041,17.9179961 C162.802147,17.6402079 162.32862,17.0111653 162.25,16.28 C162.267146,15.6370973 162.553846,15.0310364 163.04,14.61 C163.94,13.78 164.84,13.95 164.89,13.73 C164.94,13.51 163.94,12.86 162.42,13.73 C161.435938,14.4243064 160.930309,15.6162774 161.115018,16.8063708 C161.299726,17.9964643 162.142864,18.9791 163.291083,19.3424659 C164.439301,19.7058318 165.694252,19.3871591 166.53,18.52 C167.18773,17.7194538 167.418619,16.6506633 167.15,15.65 C166.68,14 165.39,13.74 165.39,13.93 Z",
    id: "Path",
    fill: "#0F1235"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8,26.12 C92.73,26.25 95,27.7 99.21,28.56 C110.565761,30.8613102 122.130157,25.6997092 128,15.71 C130.17,12 130.6,9.33 130.46,9.3 C130.32,9.27 129.46,11.72 127.11,15.14 C121.074105,24.3017709 110.272387,29.1311413 99.42,27.52 C95.29,27 92.9,25.87 92.8,26.12 Z",
    id: "Path",
    fill: "#0F1235"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M221.09,7.10996494 C220.93,7.10996494 220.6,9.27 221.36,12.68 C223.482122,21.8668691 231.243712,28.665813 240.63,29.56 C244.11,29.87 246.21,29.26 246.18,29.1 C246.15,28.94 244.05,29.1 240.77,28.51 C232.060966,27.1088761 224.920484,20.8502708 222.39,12.4 C221.39,9.23 221.34,7.1 221.09,7.10996494 Z",
    id: "Path",
    fill: "#0F1235"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.75,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(96.000000, 0.000000)",
    fill: "#0F1235"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31,0.59 L0.16,12 C23.45,15.6 121.25,30.71 150.36,35.11 L151.91,0.64 L2.31,0.59 Z",
    id: "Path"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ARMS",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360,142.2 L427.1,159.62 C427.1,159.62 482.59,98.03 485.19,95.87 C487.79,93.71 521.84,104.52 521.84,104.52 L482.31,177.74 C472.87,201.63 458.84,215.09 445.18,215.68 L335.18,193.84 L360,142.2 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,98.6 C483,98.6 490.67,83.22 491.73,80.89 C494.37,75.04 498.39,60.31 498.39,60.31 C498.39,60.31 502.96,59.31 502.67,69.52 C502.38,79.73 504.44,76.9 504.44,76.9 C504.44,76.9 525.65,51.12 530.79,52.83 C532.72,53.47 530.06,59.58 526.56,62.89 C523.898073,65.5787379 521.453733,68.4744956 519.25,71.55 C519.25,71.55 539.25,53.55 543.77,56.4 C543.77,56.4 546.01,58.16 539.67,63.47 C534.408156,67.8561421 529.471836,72.6186713 524.9,77.72 C524.9,77.72 544.69,63.72 546.9,65.27 C550.61,67.77 530.55,82 527.23,87.27 C527.23,87.27 542.15,75.83 542.55,79.5 C542.95,83.17 524.39,96.06 515.91,114.78 L483,98.6 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,79.42 C498.89,79.63 500.35,80.42 502,82.33 C504.211917,84.8189491 505.485216,88.0021977 505.6,91.33 L505.6,93.08 L506.8,91.77 L506.87,91.69 C509.108122,89.175848 512.030708,87.3687792 515.28,86.49 C517.78,85.81 519.45,85.85 519.460044,85.62 C519.47,85.39 517.79,85.06 515.06,85.53 C511.474746,86.1856865 508.215617,88.0319388 505.81,90.77 L505.73,90.86 L506.96,91.3 C506.858458,87.6484261 505.320459,84.1843368 502.68,81.66 C500.69,79.76 499,79.28 499,79.42 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,150.37 L122.9,167.8 C122.9,167.8 76.24,116.01 66.51,105.8 C64.8,102.39 59.17,91.08 58.28,89.1 C55.63,83.25 51.62,68.52 51.62,68.52 C51.62,68.52 47.04,67.52 47.33,77.73 C47.62,87.94 45.56,85.1 45.56,85.1 C28.51,53.45 16.16,69.5 15.01,72.44 C13.86,75.38 14.01,94.44 14.01,94.44 C13.69,97.33 21.01,101.8 28.3,112.68 L28.13,112.73 L67.67,185.95 C77.11,209.83 91.14,223.29 104.79,223.89 L214.79,202.05 L190,150.37 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.08,87.6 C51.03,87.46 49.35,87.94 47.32,89.83 C44.6759182,92.351788 43.1372224,95.8174486 43.04,99.47 L44.27,99.03 L44.19,98.94 C41.7863872,96.1976218 38.5268555,94.3476173 34.94,93.69 C32.22,93.22 30.52,93.64 30.55,93.79 C30.58,93.94 32.22,93.97 34.73,94.66 C37.9787298,95.5335213 40.8995129,97.3416252 43.13,99.86 L43.21,99.94 L44.4,101.25 L44.4,99.5 C44.5161619,96.1743303 45.7853248,92.992585 47.99,90.5 C49.73,88.58 51.2,87.8 51.08,87.6 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.16,36.62 L36.09,51.06 C34.7821896,54.2172907 32.6683979,56.9759095 29.96,59.06 L21.32,65.72 C20.7373225,66.1723424 20.2824108,66.7685524 20,67.45 L0.91,113.63 C0.64075494,114.281697 0.94927719,115.02841 1.6,115.3 L27.6,126.04 C28.2544638,126.30996 29.0042102,126.002029 29.28,125.35 L48.28,79.44 C48.5735216,78.7181412 48.6668009,77.9304496 48.55,77.16 L47.2,66.1 C46.8,62.76 47.38,60.27 48.55,56.27 L52.97,40.63 L43.16,36.62 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    points: "45.24 86.7 27.74 79.46 15.03 110.21 32.53 117.45"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    transform: "translate(48.873967, 36.656600) rotate(22.460000) translate(-48.873967, -36.656600) ",
    x: 41.8339674,
    y: 34.4216003,
    width: 14.08,
    height: 4.47,
    rx: 0.83
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    points: "44.17 54.59 36.07 51.24 40.35 42.36 47.93 45.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89,102.07 C37.8244117,104.645193 35.3123933,106.324836 32.5254418,106.325615 C29.7384903,106.326394 27.2255335,104.648155 26.158506,102.073558 C25.0914784,99.4989608 25.6805456,96.535106 27.6509921,94.5642077 C29.6214385,92.5933095 32.5851581,92.0035628 35.16,93.07 C36.8514461,93.7647876 38.1961117,95.1052326 38.8962134,96.794486 C39.5963151,98.4837395 39.5940789,100.3824 38.89,102.07 L38.89,102.07 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.71,88 C44.66,88.12 42.97,87.55 40.07,86.45 C37.17,85.35 33.07,83.75 28.18,81.79 L28.92,81.48 C27.21,85.69 25.26,90.48 23.2,95.48 L17.33,109.48 L17.02,108.74 C21.87,110.8 25.91,112.56 28.74,113.84 C30.2626077,114.429415 31.7286139,115.155724 33.12,116.01 C31.5287091,115.638003 29.9753802,115.11911 28.48,114.46 C25.58,113.37 21.48,111.75 16.59,109.79 L16.06,109.58 L16.28,109.05 L22,95 L27.86,81 L28.08,80.47 L28.6,80.69 C33.45,82.75 37.49,84.51 40.32,85.78 C41.847839,86.3848708 43.3172699,87.1279543 44.71,88 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.73,65.88 C23.65,69.62 25.5666667,73.3666667 27.48,77.12 C28.12,78.37 28.75,79.97 27.9,81.12 C27.1782936,81.9233095 26.030116,82.1873504 25.03,81.78 C24.0601237,81.3594659 23.2084758,80.7069937 22.55,79.88 C20.0874739,77.1890888 18.0901653,74.1069476 16.64,70.76 C16.150054,69.3993413 16.547411,67.8774641 17.64,66.93 C18.8058356,66.0425272 20.2808405,65.6638585 21.73,65.88 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.86,78.42 C15.78,82.1733333 17.6966667,85.9233333 19.61,89.67 C20.25,90.92 20.88,92.52 20.03,93.67 C19.3082936,94.4733095 18.160116,94.7373504 17.16,94.33 C16.1921823,93.9059717 15.3413138,93.2540966 14.68,92.43 C12.2174739,89.7390888 10.2201653,86.6569476 8.77,83.31 C8.28005399,81.9493413 8.67741096,80.4274641 9.77,79.48 C10.9358402,78.5921135 12.4096597,78.2101456 13.86,78.42 L13.86,78.42 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23,72.3 L24,83.54 C24.65,84.8 25.27,86.39 24.42,87.54 C23.6998835,88.3460036 22.5498627,88.6104683 21.55,88.2 C20.5828418,87.7795067 19.7319178,87.1310203 19.07,86.31 C16.6121597,83.6137357 14.6184497,80.5285539 13.17,77.18 C13.17,77.18 11.17,72.88 14.63,70.59 C18.09,68.3 18.23,72.3 18.23,72.3 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,26.08 C55.82,23.08 55.95,19.98 57.14,17.21 C58.33,14.44 60.8,12.01 63.81,11.8 C66.82,11.59 69.94,14.33 69.39,17.29 C68.91,19.88 66.2,21.35 63.72,22.23 C61.24,23.11 57.09,23.85 55.72,26.08",
    id: "Path",
    fill: "#82B3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7,17.6 C51.5831538,13.8701978 50.6649597,9.57947361 51.07,5.31 C51.24,3.63 51.73,1.78 53.18,0.9 C54.4105138,0.21208416 55.9263118,0.28981739 57.08,1.1 C58.2010389,1.92747005 58.9259486,3.18518841 59.08,4.57 C59.39,6.92 58.29,9.22 57.08,11.26 C55.87,13.3 54.46,15.31 54.08,17.65",
    id: "Path",
    fill: "#82B3E0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SHIRT",
    transform: "translate(133.000000, 137.000000)",
    fill: "#226BB5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "184.38 1 184.88 1.08 184.75 1.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,24.76 C274.7,25.76 194.08,2.85 184.88,1.1 L184.38,1.02 C174.09,-0.33 100.96,7.02 91.11,7.53 C81.26,8.04 0.39,33.11 0.39,33.11 L12.48,103.59 L75.39,90.91 L73.21,161.41 L66.69,242.63 L230,253.38 C230.39,236.96 216.52,90.64 216.52,90.64 L255.42,103.73 L276.54,24.76 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.57,24.67 L276.57,24.76 C276.57,24.76 276.6,24.72 276.57,24.67 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.88,1.1 C194.08,2.85 274.7,25.74 276.54,24.76 L276.54,24.67 L212.15,7.27 C203.193114,4.66384723 194.086391,2.60339697 184.88,1.1 L184.88,1.1 Z",
    id: "Path"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "HEAD",
    transform: "translate(212.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0594335,0.836105468 L61.9394335,0.836105468 C62.4917183,0.836105468 62.9394335,1.28382072 62.9394335,1.83610547 L62.9394335,5.83610547 L56.9394073,5.83610547 L56.9394073,1.83610547 C56.9373559,1.54872563 57.0590186,1.27434305 57.2733916,1.08293854 C57.4877647,0.891534034 57.7741238,0.801611477 58.0594335,0.836105468 Z",
    id: "Path",
    fill: "#E7515B",
    transform: "translate(59.939420, 3.332488) rotate(-10.260000) translate(-59.939420, -3.332488) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0594335,0.836105468 L61.9394335,0.836105468 C62.4917183,0.836105468 62.9394335,1.28382072 62.9394335,1.83610547 L62.9394335,5.83610547 L56.9394073,5.83610547 L56.9394073,1.83610547 C56.9373559,1.54872563 57.0590186,1.27434305 57.2733916,1.08293854 C57.4877647,0.891534034 57.7741238,0.801611477 58.0594335,0.836105468 Z",
    id: "Path",
    fill: "#000000",
    transform: "translate(59.939420, 3.332488) rotate(-10.260000) translate(-59.939420, -3.332488) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.81,103.89 C74.95,104.21 75.1,104.51 75.25,104.82 C77.5788679,109.364306 81.7170357,112.715049 86.6463454,114.04781 C91.5756551,115.38057 96.8384979,114.571622 101.14,111.82 C104.89,109.43 107.83,105.06 106.95,100.7 C108.47,102.83 111.82,103.04 113.95,101.57 C116.049108,99.9400603 117.272087,97.4275951 117.26,94.77 C117.233926,92.1517886 116.79867,89.5537504 115.97,87.07 C118.201567,88.9902855 121.47792,89.0697883 123.8,87.26 C126.023961,85.3762343 127.02118,82.4153801 126.39,79.57 C125.715621,76.7677873 123.961703,74.3453668 121.51,72.83 C123.739258,72.9537096 125.888926,71.9832162 127.270525,70.2293411 C128.652125,68.475466 129.092272,66.1583129 128.45,64.02 C127.28,60.17 123.08,58.14 119.19,57.11 C115.3,56.08 111.03,55.47 108.05,52.77 C105.875872,50.6283667 104.5057,47.803271 104.17,44.77 C103.848286,41.74983 103.881848,38.7023521 104.27,35.69 L90.11,36.06 L74.81,103.89 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,44.72 C27.5,47.72 23.43,55.61 20.83,57.28 C18.1493875,58.8157695 15.3005563,60.0371765 12.34,60.92 C9.37379766,61.7967215 6.59655897,63.2175555 4.15,65.11 C1.81,67.11 0.15,70.11 0.47,73.21 C0.79,76.31 3.65,79.08 6.71,78.72 C4.77,81.16 2.8,83.67 1.78,86.61 C0.76,89.55 0.86,93.09 2.83,95.5 C4.8,97.91 8.91,98.57 11.06,96.32 C9.13601311,100.992057 10.4959064,106.37283 14.4086381,109.569763 C18.3213699,112.766695 23.865234,113.026697 28.06,110.21 C28.9812689,115.667746 33.341194,119.894301 38.824919,120.645622 C44.308644,121.396943 49.6447144,118.498827 52,113.49",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.13,147.16 C63.31,158.89 85.76,143.36 85.76,143.36 C86.05,137.8 85.65,116.29 85.65,116.29 C85.65,116.29 105.47,113.21 105.71,93.39 C105.95,73.57 102.52,28.09 102.52,28.09 L102.52,28.09 C79.5883686,18.2315312 53.1166077,21.5605905 33.34,36.79 L30.4,39.05 C30.54,39.3 38.13,147.16 38.13,147.16 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.77,58.08 C102.46,58.42 100.51,56.92 97.77,56.91 C95.03,56.9 93.06,58.31 92.77,57.91 C92.63,57.75 92.93,57.13 93.77,56.47 C96.1691818,54.7426 99.4147461,54.7831695 101.77,56.57 C102.62,57.3 102.92,57.92 102.77,58.08 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.13,59.51 C72.82,59.85 70.87,58.36 68.13,58.34 C65.39,58.32 63.42,59.74 63.13,59.39 C62.99,59.23 63.3,58.61 64.13,57.96 C65.28853,57.1116254 66.6943969,56.6687773 68.13,56.7 C69.5746921,56.7028683 70.9790335,57.1768335 72.13,58.05 C73,58.73 73.28,59.36 73.13,59.51 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.07,82.53 C84.07,82.32 85.74,81.97 88.48,81.59 C89.2,81.52 89.76,81.35 89.81,80.97 C89.8236899,80.2695148 89.6474539,79.5783935 89.3,78.97 C88.6,77.16 87.89,75.34 87.14,73.42 C84.14,65.52 82.07,59 82.47,58.85 C82.87,58.7 85.61,64.98 88.59,72.85 L90.59,78.44 C91.0522491,79.3681209 91.1895837,80.4245408 90.98,81.44 C90.7729337,81.9928512 90.3169629,82.4154582 89.75,82.58 C89.3514717,82.6833589 88.9417031,82.7370991 88.53,82.74 C85.81,82.79 84.09,82.74 84.07,82.53 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.69,116 C85.69,116 73.17,117 59.86,108.66 C59.86,108.66 65.96,122.92 85.73,121.13 L85.69,116 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.93,33.07 C102.93,33.07 91.34,39.78 75.12,33.13 C64.47,28.77 52.32,27.13 49.83,29.41 C47.34,31.69 59.05,27.09 51.47,43.3 C51.47,43.3 43.39,83.88 31.72,66.14 C27.31,59.44 26.35,34.43 26.34,34.38 L45.34,23.31 L66.53,17.66 L87,19 L103,22.13 L102.93,33.07 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.84,59.57 C32.5,59.42 19.23,55.57 19.66,69.09 C20.09,82.61 33.6,79.4 33.66,79.01 C33.72,78.62 32.84,59.57 32.84,59.57 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31,74 C29.25,74 29.08,74.18 28.69,74.37 C28.1380072,74.6303251 27.5056682,74.6626606 26.93,74.46 C25.48,73.98 24.2,71.75 24.06,69.31 C23.9880362,68.1498592 24.1759381,66.9882837 24.61,65.91 C24.843762,65.0433011 25.4858224,64.345247 26.33,64.04 C26.8853584,63.8806163 27.4759175,64.1361065 27.74,64.65 C27.93,65.02 27.86,65.29 27.93,65.31 C28,65.33 28.21,65.08 28.09,64.52 C27.9969359,64.1905477 27.8006552,63.8996317 27.53,63.69 C27.1449373,63.4240039 26.6722062,63.316565 26.21,63.39 C25.0845034,63.6482775 24.1749658,64.4744408 23.81,65.57 C23.2703497,66.7604461 23.0333203,68.0658255 23.12,69.37 C23.29,72.09 24.77,74.6 26.74,75.11 C27.484921,75.2949048 28.2734978,75.1371894 28.89,74.68 C29.3,74.34 29.36,74 29.31,74 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,50.29 C89.91,51.03 92.5,50.29 95.63,50.23 C98.76,50.17 101.4,50.52 101.75,49.74 C102.1,48.96 99.42,47.06 95.5,47.24 C91.58,47.42 89.06,49.61 89.5,50.29 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.11,50.62 C59.52,51.37 62.11,50.68 65.24,50.57 C68.37,50.46 71.01,50.85 71.35,50.08 C71.69,49.31 69.02,47.39 65.11,47.58 C61.2,47.77 58.66,50 59.11,50.62 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.63,46.13 C37.63,46.13 137.83,32.88 141.14,29.3 C143.78,26.46 129.67,23.3 104.38,25.3 C97.68,32.92 65.89,39.61 37.63,46.13 Z",
    id: "Path",
    fill: "#E7515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,49.26 L105.73,34.35 C105.73,34.35 107.39,13.35 82.95,6.76 C67.07,2.49 49.84,5.53 37.68,16.6 C30.23,23.39 24.1,33.77 25.9,49.26 Z",
    id: "Path",
    fill: "#FCD828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.57,88 C84.8,88.3 82.64,89.72 79.77,89 C76.9,88.28 75.56,86.14 75.9,86 C76.24,85.86 77.7,87.18 80.07,87.69 C82.44,88.2 84.41,87.59 84.57,88 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,49.26 C25.9,49.26 39.43,46.58 42.68,46.13 C45.28,45.77 53,44.2 53,44.2 C81.42,40.2 139.61,31.65 141.14,29.3 C143.26,26.06 129.67,23.3 104.38,25.3 C97.68,32.92 54.15,42.74 25.9,49.26 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.87,5.33 C61.03,5.55 59.03,6.87 56.67,9.79 C55.3133563,11.5079936 54.1715732,13.3852193 53.27,15.38 C52.2163437,17.8502602 51.4383082,20.4291796 50.95,23.07 C50.1562409,27.9256089 50.0015934,32.8642416 50.49,37.76 C50.84,41.54 51.26,43.87 51.04,43.92 C50.82,43.97 50.13,41.69 49.53,37.92 C48.7343173,32.929587 48.7579611,27.8428008 49.6,22.86 C50.1028648,20.0986211 50.9494474,17.4110572 52.12,14.86 C53.116797,12.7970467 54.3994152,10.884902 55.93,9.18 C56.9484974,8.03811847 58.1077533,7.03006989 59.38,6.18 C60.29,5.54 60.81,5.25 60.87,5.33 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.81,30.67 C93.59,30.74 92.81,28.33 90.91,24.83 C85.8611885,15.585827 77.0894929,8.95152672 66.82,6.61 C62.92,5.7 60.4,5.61 60.4,5.42 C60.4,5.23 62.95,4.97 67.01,5.66 C77.7963614,7.54864958 87.0128334,14.5168385 91.77,24.38 C93.54,28.1 94,30.64 93.81,30.67 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.58,39.7 L31.64,37.6 L33.64,44.72 L25.64,47.23 C25.64,47.23 25.14,41.4 25.58,39.7 Z",
    id: "Path",
    fill: "#000000"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "CASHIER",
    transform: "translate(256.000000, 521.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1A2430",
    points: "108.92 10.09 108.92 50.94 24.31 50.94 23.35 10.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "23.35 10.09 24.31 50.94 20.36 50.94 20.36 10.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.92,10.09 L20.36,10.09 L20.36,50.94 L108.92,50.94 L108.92,10.09 Z M117.74,0.38 L124.74,117.65 L7.48,117.65 L12.2,0.38 L117.74,0.38 Z",
    id: "Shape",
    fill: "#226BB5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#226BB5",
    points: "127.15 117.65 128.4 131.2 0.8 131.2 2.79 117.65 7.48 117.65 124.79 117.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#125285",
    points: "210.98 117.65 212.98 131.2 128.4 131.2 127.15 117.65 206.59 117.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#094166",
    points: "200.39 81.75 206.59 117.65 127.15 117.65 124.79 117.65 117.74 0.38 139.69 3.52 154.79 62.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FCD828",
    points: "52.32 29.99 36.27 29.84 35.64 23.95 53.62 24.12 53.62 18.88 46.3 18.95 46.46 15.47 37.98 15.47 38.15 19.03 32.31 19.08 28.9 19.11 29.26 21.73 30.71 32.33 31 34.43 33.6 34.4 49.4 34.26 48.98 38.21 33.56 38.35 33.56 42.07 38.72 42.12 38.87 45.41 45.58 45.41 45.72 42.19 51.33 42.24 53.63 42.26 53.88 40.41 54.99 32.31 55.31 30.02"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DRINKS",
    transform: "translate(509.000000, 562.000000)",
    fillRule: "nonzero"
  }, _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    points: "69.98 25.32 62.14 25.18 57.42 25.11 58.31 40.28 63.01 40.46 69.9 40.71 88.02 41.39 88.79 25.65"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    points: "69.9 40.71 63.01 40.46 58.31 40.28 61.24 90.23 65.85 90.23 69.65 90.23 85.62 90.23 88.02 41.39"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    points: "86.02 41.31 83.81 89.02 62.14 89.02 62.14 87.29 79.85 85.71 80.1 41.09"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    style: {
      mixBlendMode: "screen"
    },
    points: "62.14 25.18 63.01 40.46 65.85 90.23 69.65 90.23 69.9 40.71 69.98 25.32"
  }), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    points: "105.85 25.32 98.01 25.18 93.28 25.11 94.17 40.28 98.88 40.46 105.77 40.71 123.88 41.39 124.66 25.65"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    points: "105.77 40.71 98.88 40.46 94.17 40.28 97.1 90.23 101.71 90.23 105.51 90.23 121.48 90.23 123.88 41.39"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    points: "121.88 41.31 119.68 89.02 98.01 89.02 98.01 87.29 115.72 85.71 115.97 41.09"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    style: {
      mixBlendMode: "screen"
    },
    points: "98.01 25.18 98.88 40.46 101.71 90.23 105.51 90.23 105.77 40.71 105.85 25.32"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0.45,0.74 L50.17,0.74 L50.17,46.68 C50.17,54.9974083 43.4274083,61.74 35.11,61.74 L15.51,61.74 C7.19259167,61.74 0.45,54.9974083 0.45,46.68 L0.45,0.74 L0.45,0.74 Z",
    id: "Path",
    fill: "#EDD5AC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    x: 21.46,
    y: 59.05,
    width: 7.69,
    height: 29.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.32,90.19 L4.32,90.19 C4.3255139,87.7859447 6.27593833,85.84 8.68,85.84 L42,85.84 C44.4024387,85.84 46.35,87.7875613 46.35,90.19 L46.32,90.19 Z",
    id: "Path",
    fill: "#EDD5AC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    x: 5.06,
    y: 20.22,
    width: 40.5,
    height: 11.02
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06,27.4 L5.06,41.24 C5.06529901,45.4613307 6.74798542,49.507514 9.73760455,52.4877554 C12.7272237,55.4679968 16.7786734,57.1379631 21,57.1300283 L29.71,57.1300283 C38.4851413,57.1244914 45.5989708,50.0151361 45.61,41.24 L45.61,27.4 L5.06,27.4 Z",
    id: "Path",
    fill: "#E32D27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,0.74 C5.25,12.5 6.01,51.55 9.55,60.85 C11.117017,61.4371271 12.7766027,61.7385621 14.45,61.74 L18.6,61.74 C17.4,55.57 11.32,23.36 10.96,0.74 L5.1,0.74 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    style: {
      mixBlendMode: "screen"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSignup);
export default __webpack_public_path__ + "static/media/illustration-signup.a42b7767833d64bced7c150b8c28b706.svg";
export { ForwardRef as ReactComponent };